import { CustomForm } from '../../../../../../../models/types/CustomForm';
import {
  FormSectionTitle,
  SectionWrapper,
} from '../../../../../../../styledComponents/Form/Form';

import FormCheckboxGroup from '../../../../../../../styledComponents/UI/Form/FormCheckboxGroup/FormCheckboxGroup';
import { FormColumn } from '../../../../../../../styledComponents/UI/Form/FormColumn/FormColumn';

import { KEMembershipOptions } from './keMembershipOptionsForm.const';
import { useKEMembershipOptions } from './keMembershipOptionsForm.hooks';

interface IMembershipOptionsFormProps extends CustomForm {
  title?: string;
}

const KEMembershipOptionsForm = ({
  className,
  disabled,
  title,
}: IMembershipOptionsFormProps) => {
  useKEMembershipOptions();
  return (
    <SectionWrapper className={className}>
      {title && <FormSectionTitle>{title}</FormSectionTitle>}
      <FormColumn>
        <FormCheckboxGroup
          layout="column"
          disabled={disabled}
          options={KEMembershipOptions}
        />
      </FormColumn>
    </SectionWrapper>
  );
};

export default KEMembershipOptionsForm;
